export const safeLocalStorage = {
  getItem(key) {
    try {
      return window.localStorage.getItem(key)
    } catch (error) {
      return null
    }
  },

  setItem(key, value) {
    try {
      window.localStorage.setItem(key, value)
    } catch (error) {
      // Safari private mode / blocked storage
    }
  },

  removeItem(key) {
    try {
      window.localStorage.removeItem(key)
    } catch (error) {
      // Safari private mode / blocked storage
    }
  },
}
